export const PROJECT_NAV_DRAWER_WIDTHS = {
  WITH_UNIT: {
    FOLDED: '80px',
    XS_SCREEN: '80vh',
    MOBILE: '33%',
    REGULAR: '240px',
  },
  RAW: {
    FOLDED: 80,
    REGULAR: 240,
  },
} as const
